import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { handleHttpError } from '@core/utils/error.utils';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageHandlerService = inject(MessageHandlerService);
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      handleHttpError(
        error,
        messageHandlerService,
        authenticationService,
        router
      );
      return throwError(() => error);
    })
  );
};
